import { getCountryByCountryCode } from 'helpers/postOffice/postOffice';
import type { PickupPointType } from 'types/pickupPoint';

export type DpdExtendedPoint = {
    id: string;
    name: string;
    location: {
        address: {
            street: string;
            city: string;
            zip: string;
            country: string;
        };
        latitude?: number | null;
        longitude?: number | null;
    };
};

export const mapDpdExtendedPoint = (point: DpdExtendedPoint): PickupPointType => ({
    identifier: point.id,
    name: point.name,
    email: null,
    telephone: null,
    description: '',
    openingHours: null,
    street: point.location.address.street,
    postcode: point.location.address.zip,
    city: point.location.address.city,
    country: getCountryByCountryCode(point.location.address.country),
    disabled: false,
    reservationDisabled: false,
    locationLatitude:
        point.location.latitude !== null && point.location.latitude !== undefined
            ? String(point.location.latitude)
            : null,
    locationLongitude:
        point.location.longitude !== null && point.location.longitude !== undefined
            ? String(point.location.longitude)
            : null,
});
